<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { useProductPage } from '../../business/use-product-page';
import { SkuSelector } from '@/features/sku-selector';
import ProductHeader from '../common/product-header.vue';
import DesktopSlider from './DesktopSlider.vue';
import ProductCTA from './ProductCTA.vue';

const { state, skuSelectorData, selectSku } = useProductPage();
const product = computed(() => state.product);

// Selected SKU product for SkuSelector
const selectedSkuProduct = ref();

// Watch for selectedSkuProduct changes from SkuSelector and update current SKU
watch(selectedSkuProduct, async (newProduct) => {
  if (newProduct?.skuId && state.product) {
    const router = useRouter();
    const skuId = parseInt(newProduct.skuId);
    // Проверяем, что SKU действительно изменился
    if (state.currentSku?.id !== skuId) {
      // Use selectSku to update current SKU, which will also update URL, price, and gallery
      await selectSku(skuId, router);
    }
  }
});

// Sync selectedSkuProduct with currentSku when currentSku changes
watch(
  () => state.currentSku,
  (newSku) => {
    if (newSku && skuSelectorData.value.products.length > 0) {
      const matchingProduct = skuSelectorData.value.products.find(
        (p) => p.skuId === newSku.id?.toString()
      );
      if (matchingProduct && selectedSkuProduct.value?.skuId !== matchingProduct.skuId) {
        selectedSkuProduct.value = matchingProduct;
      }
    }
  },
  { immediate: true }
);
</script>

<template>
  <div class="product-body">
    <ProductHeader />

    <div class="product-body__columns">
      <div class="product-body__slider-wrapper">
        <DesktopSlider
          class="product-body__slider"
          :photos="(product?.photos || []) as any[]"
          :alt="product?.title || ''"
          :circularPhotos="product?.circularPhotos.map((e) => e.link.high) || []"
          :video="product?.video || null"
        />
      </div>

      <div class="product-body__columns__right">
        <SkuSelector
          v-if="skuSelectorData.products.length > 0"
          v-model="selectedSkuProduct"
          :products="skuSelectorData.products"
          :characteristics="skuSelectorData.characteristics"
        />
        <ProductCTA />
      </div>
    </div>
  </div>
</template>

<style lang="stylus" scoped>
.product-body
  display flex
  flex-direction column
  gap 20px

  &__slider-wrapper
    height 100%

  &__slider
    position sticky
    top 24px

  &__columns
    display grid
    gap 40px
    grid-template-columns 1fr 397px
    grid-template-rows 1fr

    &__right
      display flex
      flex-direction column
      gap 44px
</style>
